import { useQuery } from '@tanstack/react-query';
import { apiClient, type ApiResponse } from '@/lib/api-client';

export interface Announcement {
  id: string;
  title: string;
  body: string;
  priority: 'info' | 'warning' | 'critical';
  publishedAt: string | null;
  expiresAt: string | null;
}

/**
 * Fetches active, non-expired platform announcements from the API.
 * Refreshes every 5 minutes so users see new announcements without reloading.
 */
export function useAnnouncements() {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<Announcement[]>>('/announcements');
      return response.data.data ?? [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000,
  });
}
